import { useEffect, useState, type ReactElement } from 'react';

import { AuthService } from '../../services/AuthService';

import { PageWrapperHeader } from './components/Header';
import { PageWrapperSidebar } from './components/Sidebar';
import { PageWrapperSidebarDivider } from './components/Sidebar/components/Divider';
import { PageWrapperSidebarItemLink } from './components/Sidebar/components/Item/PageWrapperSidebarItemLink';
import { PageWrapperSidebarItemButton } from './components/Sidebar/components/Item/PageWrapperSidebarItemButton';
import { AccordionMenuItem } from '../AccordionMenuItem';
import { ReactComponent as OnlineStore } from './Icons/online-store-laptop-ecommerce.svg';
import { ReactComponent as ShoppingCart } from './Icons/shopping-cart.svg';
import { ReactComponent as ShoppingBag } from './Icons/shopping-bag.svg';
import { ReactComponent as PriceVoucher } from './Icons/price-voucher-discount-offer.svg';
import { ReactComponent as ProfileSvg } from './Icons/profile.svg';
import { ReactComponent as ProviderIcon } from './Icons/provider-icon.svg';
import { ReactComponent as BannersIcon } from './Icons/banners2.svg';
import { ReactComponent as SettingsIcon } from './Icons/settings2.svg';
import { ReactComponent as AddedUserIcon } from './Icons/shield-plus2.svg';
import ExitIcon from '../../assets/icon/components/ExitIcon';
import { ReactComponent as ChatIcon } from './Icons/chat2.svg';
import MobileMenu from './components/MobileMenu';
import useIsMobile from './../../hooks/useIsMobile';
import { ProductPageModal } from '../ProductPageModal/ProductPageModal';
import { TechnicalErrorModal } from '../TechnicalErrorModal/TechnicalErrorModal';
import './wrapper.css';

interface Props {
  children: ReactElement | ReactElement[];
}

export const VENDOR_TABLES = [
  { title: 'Действия с товарами', href: '/vendor-actions' },
  { title: 'Заявки поставщикам', href: '/vendor-applications' }
  // { title: 'Заказанные товары', href: '/ordered-goods' }
];

export const BANNER_PAGES = [
  { title: 'Баннеры главной', href: '/banners' },
  { title: 'Баннеры брендов', href: '/banners-brends' }
];

export const PRODUCT_PAGES = [
  { title: 'Текущие товары', href: '/products' },
  { title: 'Нашли дешевле', href: '/cheapers' }
];

export const FEEDBACK_PAGES = [
  { title: 'Отзывы', href: '/reviews' }
  // TODO: добавить страницу с вопросами, когда будет готов бэкенд для нее
  // { title: 'Вопросы', href: '/questions' }
];

export const PageWrapper: React.FC<Props> = ({ children }) => {
  const [isShortSideBar, setIsShortSideBar] = useState(true);
  const [isVendorAccordionOpen, setIsVendorAccordionOpen] = useState(false);
  const [isBannerAccordionOpen, setIsBannerAccordionOpen] = useState(false);
  const [isProductAccordionOpen, setIsProductAccordionOpen] = useState(false);
  const [isFeedbackAccordionOpen, setIsFeedbackAccordionOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isMobile } = useIsMobile();
  const classWrapper = isShortSideBar ? 'wrapper-short' : 'wrapper';

  useEffect(() => {
    if (
      isVendorAccordionOpen ||
      isBannerAccordionOpen ||
      isProductAccordionOpen ||
      isFeedbackAccordionOpen
    ) {
      setIsShortSideBar(false);
    }
  }, [
    isVendorAccordionOpen,
    isBannerAccordionOpen,
    isProductAccordionOpen,
    isFeedbackAccordionOpen
  ]);

  const handleBurgerMenuClick = (): void => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div>
      <PageWrapperHeader
        onBurgerMenuClick={handleBurgerMenuClick}
        isMobile={isMobile}
      />
      <div className={classWrapper}>
        <PageWrapperSidebar
          setIsShortSideBar={setIsShortSideBar}
          isShortSideBar={isShortSideBar}
          setIsVendorAccordionOpen={setIsVendorAccordionOpen}
          setIsBannerAccordionOpen={setIsBannerAccordionOpen}
          setIsProductAccordionOpen={setIsProductAccordionOpen}
          setIsFeedbackAccordionOpen={setIsFeedbackAccordionOpen}
          className={isMobile ? 'd-none' : ''}
        >
          <div className="wrapper-items">
            <div>
              <PageWrapperSidebarDivider />
              <PageWrapperSidebarItemLink
                Icon={OnlineStore}
                title="Главная"
                href="/"
                isShortSideBar={isShortSideBar}
              />
              <PageWrapperSidebarItemLink
                Icon={ShoppingCart}
                title="Заказы"
                href="/orders"
                isShortSideBar={isShortSideBar}
              />
              <AccordionMenuItem
                setIsShortSideBar={setIsShortSideBar}
                isShortSideBar={isShortSideBar}
                setIsAccordionOpen={setIsProductAccordionOpen}
                isAccordionOpen={isProductAccordionOpen}
                title="Товары"
                items={PRODUCT_PAGES}
                IconComponent={ShoppingBag}
              />
              <PageWrapperSidebarItemLink
                Icon={PriceVoucher}
                title="Промокоды"
                href="/promocodes"
                isShortSideBar={isShortSideBar}
              />
              <PageWrapperSidebarItemLink
                Icon={ProfileSvg}
                title="Клиенты"
                href="/clients"
                isShortSideBar={isShortSideBar}
              />
              {/* <PageWrapperSidebarItemLink
                Icon={ProviderIcon}
                title="Поставщики"
                href="/vendors"
                isShortSideBar={isShortSideBar}
              /> */}
              <AccordionMenuItem
                setIsShortSideBar={setIsShortSideBar}
                isShortSideBar={isShortSideBar}
                setIsAccordionOpen={setIsVendorAccordionOpen}
                isAccordionOpen={isVendorAccordionOpen}
                title="Поставщики"
                items={VENDOR_TABLES}
                IconComponent={ProviderIcon}
              />
              <AccordionMenuItem
                setIsShortSideBar={setIsShortSideBar}
                isShortSideBar={isShortSideBar}
                setIsAccordionOpen={setIsBannerAccordionOpen}
                isAccordionOpen={isBannerAccordionOpen}
                title="Баннеры"
                items={BANNER_PAGES}
                IconComponent={BannersIcon}
              />
              <PageWrapperSidebarItemLink
                Icon={AddedUserIcon}
                title="Менеджеры"
                href="/managers"
                isShortSideBar={isShortSideBar}
              />
              <AccordionMenuItem
                setIsShortSideBar={setIsShortSideBar}
                isShortSideBar={isShortSideBar}
                setIsAccordionOpen={setIsFeedbackAccordionOpen}
                isAccordionOpen={isFeedbackAccordionOpen}
                title="Обратная связь"
                items={FEEDBACK_PAGES}
                IconComponent={ChatIcon}
              />
              <PageWrapperSidebarItemLink
                Icon={SettingsIcon}
                title="Настройки"
                href="/settings"
                isShortSideBar={isShortSideBar}
              />
              <PageWrapperSidebarDivider />
            </div>
            <PageWrapperSidebarItemButton
              Icon={ExitIcon}
              isShortSideBar={isShortSideBar}
              title="Выйти"
              onClick={() => {
                AuthService.logout();
              }}
            />
          </div>
        </PageWrapperSidebar>
        <main className="main">{children}</main>
      </div>
      <MobileMenu
        isShortSideBar={false}
        setIsShortSideBar={setIsShortSideBar}
        setIsVendorAccordionOpen={setIsVendorAccordionOpen}
        setIsBannerAccordionOpen={setIsBannerAccordionOpen}
        setIsProductAccordionOpen={setIsProductAccordionOpen}
        isVendorAccordionOpen={isVendorAccordionOpen}
        isBannerAccordionOpen={isBannerAccordionOpen}
        isProductAccordionOpen={isProductAccordionOpen}
        isFeedbackAccordionOpen={isFeedbackAccordionOpen}
        setIsFeedbackAccordionOpen={setIsFeedbackAccordionOpen}
        OnlineStore={OnlineStore}
        ShoppingCart={ShoppingCart}
        ShoppingBag={ShoppingBag}
        PriceVoucher={PriceVoucher}
        ProfileSvg={ProfileSvg}
        ProviderIcon={ProviderIcon}
        BannersIcon={BannersIcon}
        SettingsIcon={SettingsIcon}
        AddedUserIcon={AddedUserIcon}
        ChatIcon={ChatIcon}
        show={isMenuOpen}
        handleClose={handleBurgerMenuClick}
        className={isMobile ? '' : 'd-none'}
      />
      <ProductPageModal />
      <TechnicalErrorModal />
    </div>
  );
};
